import { render, staticRenderFns } from "./view-ipf.vue?vue&type=template&id=00b2a8e2"
import script from "./view-ipf.vue?vue&type=script&lang=js"
export * from "./view-ipf.vue?vue&type=script&lang=js"
import style0 from "./view-ipf.vue?vue&type=style&index=0&id=00b2a8e2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports